import {DoraProperty} from '../../../Decorators/Decorator';

export class PublisherParameter {
    @DoraProperty
    public name = '';
    @DoraProperty
    public value = '';
}
